var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Container, CssBaseline, Grid, TextField, Typography } from '@material-ui/core';
import { ProductImage } from '../../organisms/ProductImage';
import { Description } from '../../organisms/Description';
import { CouponName } from '../../organisms/CouponName';
import { SmartCheckUseButton } from '../../organisms/SmartCheckUseButton';
import { CompanyImage } from '../../organisms/CompanyImage';
import { SmartCheckHeaderImage } from '../../organisms/SmartCheckHeaderImage';
import { useSmartCheckCommonStyles } from './SmartCheckTemplate';
import { HtmlText } from '../../molcules/HtmlText';
import { CompanyName } from '../../organisms/CompanyName';
import { useForm, Controller } from 'react-hook-form';
/**
 * SmartCheck使用前テンプレート
 */
export var SmartCheckBeforeUseTemplate = function (props) {
    var _a, _b, _c, _d;
    var classes = useSmartCheckCommonStyles();
    // 表示期間内で有効期限前の場合は、消込ボタンを及びコード入力欄を非表示にする
    var clearable = props.available.validity === 'before' && props.available.displayable === 'display';
    // HTML5標準のバリデーションだとコード入力のテキストフィールドのエラーメッセージを制御しづらいので、おとなしくReact Hook Formを使う
    var _e = useForm({
        defaultValues: {
            clearingCode: '',
        },
        mode: 'onSubmit',
    }), handleSubmit = _e.handleSubmit, control = _e.control, errors = _e.formState.errors;
    return (React.createElement("form", { onSubmit: handleSubmit(props.handlers.onUseSubmit), autoComplete: "off", noValidate: true },
        React.createElement(Container, { disableGutters: true },
            React.createElement(CssBaseline, null),
            React.createElement(Grid, { container: true, justifyContent: "center", alignItems: "center" },
                React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                    React.createElement(CompanyImage, { imageUrl: props.data.companyImageUrl })),
                React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                    React.createElement(SmartCheckHeaderImage, { imageUrl: (_a = props.data.smartCheckImageUrl) === null || _a === void 0 ? void 0 : _a.smartCheckHeaderImageUrl })),
                props.layoutPattern === 'normal' || props.layoutPattern === 'product' ? (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                    React.createElement(CompanyName, __assign({}, props.data.organizationName)))) : (React.createElement(React.Fragment, null)),
                React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                    React.createElement(CouponName, __assign({}, props.data.couponName))),
                props.data.productImage ? (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                    React.createElement(ProductImage, __assign({}, props.data.productImage)))) : (React.createElement(React.Fragment, null)),
                props.errorMessage ? (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                    React.createElement(Typography, { align: "center", color: "error", variant: "body1" }, props.errorMessage))) : (React.createElement(React.Fragment, null)),
                !clearable ? (React.createElement(React.Fragment, null,
                    React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                        React.createElement(Controller, { name: "clearingCode", control: control, defaultValue: "", rules: {
                                required: 'コード番号を入力してください',
                                pattern: {
                                    value: /^[0-9]+$/,
                                    message: '半角数字で入力してください',
                                },
                                maxLength: 32,
                            }, render: function (_a) {
                                var _b, _c;
                                var _d = _a.field, ref = _d.ref, remain = __rest(_d, ["ref"]);
                                return (React.createElement(TextField, __assign({ required: true, fullWidth: true, label: "\u30B3\u30FC\u30C9\u5165\u529B", placeholder: props.layoutPattern === 'bigShopName' ? 'コード番号を入力' : 'コード番号を入力してください', type: "tel", size: "small", inputMode: "tel", margin: "normal", variant: "outlined", error: !!errors, helperText: (_c = (_b = errors.clearingCode) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : '', InputLabelProps: {
                                        shrink: true,
                                    }, inputProps: props.layoutPattern === 'bigShopName'
                                        ? {
                                            style: {
                                                fontSize: '30px',
                                            },
                                            maxLength: 32,
                                        }
                                        : {
                                            maxLength: 32,
                                        }, InputProps: {
                                        inputRef: ref,
                                    } }, remain)));
                            } })),
                    React.createElement(Grid, { item: true, xs: 12, className: classes.centerSection },
                        React.createElement(SmartCheckUseButton, { imageUrl: (_b = props.data.smartCheckImageUrl) === null || _b === void 0 ? void 0 : _b.smartCheckUseButtonImageUrl, loading: props.confirmLoading })))) : (React.createElement(React.Fragment, null)),
                ((_c = props.data.smartCheckSetting) === null || _c === void 0 ? void 0 : _c.smartCheckUseButtonBottomText) ? (React.createElement(Grid, { item: true, xs: 12, className: classes.centerSection },
                    React.createElement(HtmlText, { text: (_d = props.data.smartCheckSetting) === null || _d === void 0 ? void 0 : _d.smartCheckUseButtonBottomText }))) : (React.createElement(React.Fragment, null)),
                React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                    React.createElement(Typography, { align: "right", variant: 'body1' }, props.data.barcode.barcodeValue))),
            React.createElement(Description, __assign({}, props.data.description)))));
};
//# sourceMappingURL=SmartCheckBeforeUseTemplate.js.map